import React from "react";
import { Flex } from "@theorgchartdev/storybook";
import UpgradeButtons from "./UpgradeButtons";
import { enumFeaturesList } from "@coreapp/constants";

interface UpgradeInfoContainerProps {
  featureKey: (typeof enumFeaturesList)[keyof typeof enumFeaturesList];
}

const UpgradeInfoContainer = ({
  featureKey,
  children
}: React.PropsWithChildren<UpgradeInfoContainerProps>) => {
  return (
    <>
      <Flex
        direction={"column"}
        padding={"24px"}
        gap="24px"
        alignItems={"center"}
        justifyContent={"flex-start"}
        className="ocn-list-scrollbar"
        style={{ overflowY: "auto", maxHeight: "100%" }}
      >
        <Flex gap={"24px"} alignItems={"stretch"} direction={"row"} justifyContent={"center"}>
          {children}
        </Flex>
        <UpgradeButtons featureKey={featureKey} />
      </Flex>
    </>
  );
};

export default UpgradeInfoContainer;
